import { render } from "./search-filter-requisitions.vue?vue&type=template&id=8af42f3c"
import script from "./search-filter-requisitions.vue?vue&type=script&lang=js"
export * from "./search-filter-requisitions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__